"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _Footer = _interopRequireDefault(require("../../components/Nav/Footer"));
var _Header = _interopRequireDefault(require("../../components/Nav/Header"));
var _globalDataContext = require("../../lib/globalDataContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

var FinproStateLayout = props => {
  var route = props.route;
  (0, _globalDataContext.setGlobalData)(props);
  var pageProps = {
    displayTitle: route.fields.DisplayTitle.value,
    displayTagline: route.fields.DisplayTagline.value,
    disclaimer: route.fields.Disclaimer.value,
    showBreadCrumb: route.fields.ShowBreadcrumb.value,
    utagSiteName: props.headTagsProps.utagSiteName,
    addUtagLoginCookie: props.headTagsProps.addUtagLoginCookie
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.VisitorIdentification, null), /*#__PURE__*/_react.default.createElement(_Header.default, {
    route: route,
    params: props.componentProps,
    headTagsProps: props.headTagsProps
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(route.fields.IsFullWidthLayout.value ? 'finpro-fullwidth-layout' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: "main-content-full-body",
    rendering: route,
    params: props.componentProps,
    pageprops: pageProps
  })), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    fields: route.fields,
    componentParams: props.componentProps,
    params: props.headTagsProps
  })));
};
var _default = exports.default = FinproStateLayout;